import { HeartIcon, CareIcon, ThumbSubIcon } from '../../../../components';
import {
  ReactionContainer,
  StyledReactinButton,
  LoadedText,
} from './Reactions.styles';

function ReactionLoader({ className }: { className: string }): JSX.Element {
  return (
    <ReactionContainer className={className}>
      <StyledReactinButton>
        <HeartIcon />
        <LoadedText />
      </StyledReactinButton>
      <StyledReactinButton>
        <ThumbSubIcon />
        <LoadedText />
      </StyledReactinButton>
      <StyledReactinButton>
        <CareIcon />
        <LoadedText />
      </StyledReactinButton>
    </ReactionContainer>
  );
}

ReactionLoader.default = {
  className: '',
};

export default ReactionLoader;
